import { ApplicationUser } from './application-user';

export class AuthenticationResult {
  isPasswordValid: boolean;
  isMfaRequired: boolean;
  isAccountLocked: boolean;
  isAccountActivated: boolean;
  isAuthenticated: boolean; // Computed property equivalent to IsAuthenticated
  authenticationFailedReason: string;
  accessLevel: number;
  mfaRequestReason: string;
  user: ApplicationUser;
  userData: any;
  token: string;
  tokenExpirationDate: Date;

  // Constructor to initialize the object
  constructor(data: Partial<AuthenticationResult> = {}) {
    this.isPasswordValid = data.isPasswordValid || false;
    this.isMfaRequired = data.isMfaRequired || false;
    this.isAccountLocked = data.isAccountLocked || false;
    this.isAccountActivated = data.isAccountActivated || false;
    this.isAuthenticated =
      this.isAccountActivated &&
      this.isPasswordValid &&
      !this.isAccountLocked &&
      !this.isMfaRequired;
    this.authenticationFailedReason = data.authenticationFailedReason || '';
    this.accessLevel = data.accessLevel || 0; // Default to 0 if not provided
    this.mfaRequestReason = data.mfaRequestReason || '';
    this.user = data.user || null;
    this.userData = data.userData || null;
    this.token = data.token || '';
    this.tokenExpirationDate = data.tokenExpirationDate ? new Date(data.tokenExpirationDate) : null;
  }
}
